export class ExcludedAgendaTaskType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
